<!-- gift.component.html -->
<div class="gift-list-container">
    <!-- 載入狀態 -->
    <div *ngIf="loading" class="loading-overlay">
        <div class="spinner"></div>
        <p>載入中...</p>
    </div>

    <!-- 主要內容 -->
    <div *ngIf="!loading">
        <!-- 頂部操作欄 -->
        <div class="header-actions">
            <h2 class="page-title">實體禮物管理</h2>
            <div class="action-buttons">
                <!-- 現有按鈕保持不變 -->
                <button class="btn-success" (click)="giftCategory()">
                    禮物類別
                </button>

                <!-- 新增兌換申請單按鈕 -->
                <button class="btn-info" (click)="openRedemptionManagement()">
                    <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                        <path d="M3 8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 8zm0 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>
                    </svg>
                    兌換申請單
                </button>

                <button class="btn-primary" (click)="addNewGift()">
                    <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    新增禮物
                </button>

                <button class="btn-secondary" (click)="refreshList()">
                    <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                    </svg>
                    重新載入
                </button>
            </div>
        </div>

        <!-- 篩選區域 -->
        <div class="filter-section">
            <div class="search-bar">
                <input
                    type="text"
                    placeholder="搜尋禮物名稱或分類..."
                    [(ngModel)]="searchTerm"
                    (input)="filterGifts()"
                    class="search-input"
                />
                <svg class="search-icon" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                </svg>
            </div>

            <div class="filter-tabs">
                <button
                    class="filter-tab"
                    [class.active]="selectedCategory === 'all'"
                    (click)="filterByCategory('all')"
                >
                    全部 ({{ gifts.length }})
                </button>
                <button
                    *ngFor="let cat of categories"
                    class="filter-tab"
                    [class.active]="selectedCategory === cat.id"
                    (click)="filterByCategory(cat.id)"
                >
                    {{ cat.name }} ({{ getGiftCountByCategory(cat.id) }})
                </button>
            </div>

            <div class="view-controls">
                <div class="view-toggle">
                    <button
                        class="view-btn"
                        [class.active]="viewMode === 'grid'"
                        (click)="viewMode = 'grid'"
                        title="網格視圖"
                    >
                        <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3A1.5 1.5 0 0 1 15 10.5v3A1.5 1.5 0 0 1 13.5 15h-3A1.5 1.5 0 0 1 9 13.5v-3z"/>
                        </svg>
                    </button>
                    <button
                        class="view-btn"
                        [class.active]="viewMode === 'list'"
                        (click)="viewMode = 'list'"
                        title="列表視圖"
                    >
                        <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                </div>

                <div class="result-count">
                    顯示 {{ filteredGifts.length }} / {{ gifts.length }} 項禮物
                </div>
            </div>
        </div>

        <!-- 網格視圖 -->
        <div *ngIf="viewMode === 'grid'" class="gift-grid">
            <div
                *ngFor="let gift of filteredGifts; trackBy: trackByGiftId"
                class="gift-card"
                [class.disabled]="gift.status !== '1'"
            >
                <div class="gift-image-container">
                    <img loading="lazy" [src]="gift.image" [alt]="gift.name" class="gift-image" (error)="onImageError($event)" />
                    <div class="gift-status" [ngClass]="getStatusClass(gift.status)">
                        {{ getStatusText(gift.status) }}
                    </div>
                    <div class="gift-category-badge">{{ gift.category_name }}</div>
                    <div class="gift-id-badge">ID: {{ gift.id }}</div>
                </div>

                <div class="gift-info">
                    <h3 class="gift-name" [title]="gift.name">{{ gift.name }}</h3>
                    <div class="gift-details">
                        <div class="price-info">
                            <div class="cost-section">
                                <span class="label">消費:</span>
                                <span class="cost">{{ numberToThousand(gift.cost_diamond) }} 💎</span>
                            </div>
                            <div class="convert-section" *ngIf="gift.convert_diamond !== '0'">
                                <span class="label">轉換:</span>
                                <span class="convert">{{ numberToThousand(gift.convert_diamond) }} 💎</span>
                            </div>
                        </div>

                        <div class="meta-info">
                            <div class="stock-info">
                                <span class="stock">庫存: {{ gift.stock }}</span>
                                <span class="limit">限制: {{ getExchangeLimit(gift.exchange_limit) }}</span>
                            </div>

                            <div class="expire-info">
                                <!-- <span class="expire">有效期: {{ gift.expire }}天</span> -->
                                <span class="exchange">集滿兌: {{ gift.exchange_count }}</span>
                            </div>
                        </div>

                        <div class="date-info">
                            <small class="create-date">建立: {{ formatDate(gift.create_dt) }}</small>
                            <small class="update-date">更新: {{ formatDate(gift.update_dt) }}</small>
                        </div>
                    </div>
                </div>

                <div class="gift-actions">
                    <button class="edit-btn" (click)="editGift(gift)">
                        <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708L10.5 8.207l-3-3L12.146.146zM11.207 9L8 5.793 1.146 12.646a.5.5 0 0 0-.146.354v2.5a.5.5 0 0 0 .5.5h2.5a.5.5 0 0 0 .354-.146L11.207 9zM4 15.5a.5.5 0 0 1-.5-.5v-2.293l1.5-1.5v3.793h-1z"/>
                        </svg>
                        編輯
                    </button>
                    <button class="toggle-btn" [class.enable]="gift.status === '1'" (click)="toggleStatus(gift)">
                        {{ gift.status === '1' ? '停用' : '啟用' }}
                    </button>
                    <button class="delete-btn" (click)="deleteGift(gift)">
                        <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                            <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                        </svg>
                        刪除
                    </button>
                </div>
            </div>
        </div>

        <!-- 列表視圖 -->
        <div *ngIf="viewMode === 'list'" class="gift-list">
            <div class="list-header">
                <div class="col-image">圖片</div>
                <div class="col-name">名稱</div>
                <div class="col-category">分類</div>
                <div class="col-price">鑽石</div>
                <div class="col-stock">庫存</div>
                <div class="col-stock">集滿兌</div>
                <div class="col-stock">限換數</div>
                <!-- <div class="col-expire">有效期限</div> -->
                <div class="col-expire">建立時間</div>
                <div class="col-expire">更新時間</div>
                <div class="col-status">狀態</div>
                <div class="col-actions">操作</div>
            </div>

            <div
                *ngFor="let gift of filteredGifts; trackBy: trackByGiftId"
                class="list-item"
                [class.disabled]="gift.status !== '1'"
            >
                <div class="col-image">
                    <img loading="lazy" [src]="gift.image" [alt]="gift.name" class="list-image" (error)="onImageError($event)" />
                </div>
                <div class="col-name">
                    <div class="name-with-id">
                        <strong>{{ gift.name }}</strong>
                        <small>ID: {{ gift.id }}</small>
                    </div>
                </div>
                <div class="col-category">
                    <div class="category-info">
                        <span class="main-category">{{ gift.category_parent_name }}</span>
                        <span class="sub-category">{{ gift.category_name }}</span>
                    </div>
                </div>
                <div class="col-price">
                    <div class="price-details">
                        <div class="cost">消費: {{ numberToThousand(gift.cost_diamond) }}</div>
                        <div class="convert" *ngIf="gift.convert_diamond !== '0'">
                            轉換: {{ numberToThousand(gift.convert_diamond) }}
                        </div>
                    </div>
                </div>
                <div class="col-stock">{{ gift.stock }}</div>
                <div class="col-stock">{{ gift.exchange_count }}</div>
                <div class="col-stock">{{ gift.exchange_limit }}</div>
                <!-- <div class="col-expire">{{ gift.expire }}天</div> -->
                <div class="col-expire">{{ gift.create_dt }}</div>
                <div class="col-expire">{{ gift.update_dt }}</div>
                <div class="col-status">
                    <span class="status-badge" [ngClass]="getStatusClass(gift.status)">
                        {{ getStatusText(gift.status) }}
                    </span>
                </div>
                <div class="col-actions">
                    <button class="action-btn edit" (click)="editGift(gift)" title="編輯">
                        <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708L10.5 8.207l-3-3L12.146.146zM11.207 9L8 5.793 1.146 12.646a.5.5 0 0 0-.146.354v2.5a.5.5 0 0 0 .5.5h2.5a.5.5 0 0 0 .354-.146L11.207 9z"/>
                        </svg>
                    </button>
                    <button class="action-btn toggle" [class.enable]="gift.status === '1'" (click)="toggleStatus(gift)" title="切換狀態">
                        <svg *ngIf="gift.status === '1'" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.061L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                        </svg>
                        <svg *ngIf="gift.status !== '1'" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                        </svg>
                    </button>
                    <button class="action-btn delete" (click)="deleteGift(gift)" title="刪除">
                        <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                            <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <!-- 空狀態 -->
        <div *ngIf="filteredGifts.length === 0 && !loading" class="empty-state">
            <div class="empty-icon">
                <svg width="64" height="64" fill="#dee2e6" viewBox="0 0 16 16">
                    <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"/>
                </svg>
            </div>
            <h3>沒有找到禮物</h3>
            <p>{{ searchTerm ? '嘗試調整搜尋條件' : '目前沒有任何禮物資料' }}</p>
            <button class="btn-primary" (click)="addNewGift()">新增第一個禮物</button>
        </div>
    </div>
</div>

<!-- 統一的禮物彈跳視窗 -->
<div *ngIf="showGiftModal" class="modal-overlay" (click)="onModalBackdropClick($event)">
    <div class="modal-container">
        <div class="modal-header">
            <h3 class="modal-title">{{ isEditMode ? '編輯禮物' : '新增禮物' }}</h3>
            <button class="modal-close" (click)="closeGiftModal()">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <form class="edit-form" (ngSubmit)="saveGift()">
                <!-- 基本資訊區塊 -->
                <div class="form-section">
                    <h4 class="section-title">基本資訊</h4>
                    <div class="form-grid">
                        <div class="form-group">
                            <label class="form-label">禮物名稱 <span class="required">*</span></label>
                            <input
                                type="text"
                                class="form-input"
                                [(ngModel)]="editForm.name"
                                name="name"
                                placeholder="請輸入禮物名稱"
                                required
                            />
                        </div>

                        <div class="form-group">
                            <label class="form-label">分類 {{ !isEditMode ? '*' : '' }}</label>
                            <select class="form-select" [(ngModel)]="editForm.category" name="category" [required]="!isEditMode">
                                <option value="">請選擇分類</option>
                                <option *ngFor="let cat of categories" [value]="cat.id">
                                    {{ cat.parent_name }} - {{ cat.name }}
                                </option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label class="form-label">狀態</label>
                            <div class="radio-group">
                                <label class="radio-item">
                                    <input type="radio" [(ngModel)]="editForm.status" name="status" value="1" />
                                    <span class="radio-label">啟用</span>
                                </label>
                                <label class="radio-item">
                                    <input type="radio" [(ngModel)]="editForm.status" name="status" value="0" />
                                    <span class="radio-label">停用</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 價格設定區塊 -->
                <div class="form-section">
                    <h4 class="section-title">價格設定</h4>
                    <div class="form-grid">
                        <div class="form-group">
                            <label class="form-label">消費鑽石 <span class="required">*</span></label>
                            <div class="input-with-icon">
                                <input
                                    type="number"
                                    class="form-input"
                                    [(ngModel)]="editForm.cost_diamond"
                                    name="cost_diamond"
                                    placeholder="0"
                                    min="0"
                                    required
                                />
                                <span class="input-icon">💎</span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="form-label">轉換鑽石</label>
                            <div class="input-with-icon">
                                <input
                                    type="number"
                                    class="form-input"
                                    [(ngModel)]="editForm.convert_diamond"
                                    name="convert_diamond"
                                    placeholder="0"
                                    min="0"
                                />
                                <span class="input-icon">💎</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 庫存設定區塊 -->
                <div class="form-section">
                    <h4 class="section-title">庫存與限制</h4>
                    <div class="form-grid">
                        <div class="form-group">
                            <label class="form-label">庫存數量</label>
                            <input
                                type="number"
                                class="form-input"
                                [(ngModel)]="editForm.stock"
                                name="stock"
                                placeholder="0"
                                min="0"
                            />
                        </div>

                        <div class="form-group">
                            <label class="form-label">集滿兌</label>
                            <input
                                type="number"
                                class="form-input"
                                [(ngModel)]="editForm.exchange_count"
                                name="exchange_count"
                                placeholder="1"
                                min="1"
                            />
                            <small class="form-hint">集多少個可以兌換</small>
                        </div>

                        <div class="form-group">
                            <label class="form-label">女生兌換限制</label>
                            <input
                                type="number"
                                class="form-input"
                                [(ngModel)]="editForm.exchange_limit"
                                name="exchange_limit"
                                placeholder="999999999"
                                min="1"
                            />
                            <small class="form-hint">設定為 999999999 表示無限制</small>
                        </div>

                          <div class="form-group">
                            <label class="form-label">男生購買限制</label>
                            <input
                                type="number"
                                class="form-input"
                                [(ngModel)]="editForm.buy_limit"
                                name="buy_limit"
                                placeholder="999999999"
                                min="1"
                            />
                            <small class="form-hint">設定為 999999999 表示無限制</small>
                        </div>

                        <!-- <div class="form-group">
                            <label class="form-label">有效期限 <span class="required">*</span></label>
                            <div class="input-with-unit">
                                <input
                                    type="number"
                                    class="form-input"
                                    [(ngModel)]="editForm.expire"
                                    name="expire"
                                    placeholder="30"
                                    min="1"
                                    required
                                />
                                <span class="input-unit">天</span>
                            </div>
                        </div> -->
                    </div>
                </div>

                <!-- 圖片上傳區塊 -->
                <div class="form-section">
                    <h4 class="section-title">禮物圖片 {{ !isEditMode ? '*' : '' }}</h4>

                    <div class="image-upload-container">
                        <!-- 有圖片時的顯示 -->
                        <div class="current-image" *ngIf="imagePreviewUrl">
                            <img loading="lazy" [src]="imagePreviewUrl" [alt]="editForm.name" class="image-display"
                                 (error)="onImageError($event)" (load)="onImageLoad($event)" />
                            <div class="image-actions">
                                <button type="button" class="upload-btn" (click)="fileInput.click()">
                                    <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                        <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
                                    </svg>
                                    {{ selectedFile ? '更換圖片' : isEditMode ? '上傳新圖片' : '選擇圖片' }}
                                </button>

                                <button type="button" class="reset-btn" (click)="resetImage()" *ngIf="selectedFile || !isEditMode">
                                    <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                                    </svg>
                                    {{ isEditMode && editingGift ? '恢復原圖' : '移除圖片' }}
                                </button>
                            </div>
                        </div>

                        <!-- 沒有圖片時的上傳區域 -->
                        <div class="upload-area" *ngIf="!imagePreviewUrl">
                            <div class="upload-content" (click)="fileInput.click()">
                                <div class="upload-icon">
                                    <svg width="48" height="48" fill="#667eea" viewBox="0 0 16 16">
                                        <path d="M.002 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2V3zm1 9v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12zm5-6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z"/>
                                    </svg>
                                </div>
                                <p class="upload-text">點擊選擇禮物圖片</p>
                                <p class="upload-hint">支援 JPG、PNG、GIF 格式，大小不超過 5MB</p>
                            </div>
                        </div>

                        <!-- 隱藏的檔案輸入 -->
                        <input
                            type="file"
                            #fileInput
                            style="display: none;"
                            accept="image/*"
                            (change)="onFileSelected($event)"
                        />

                        <!-- 上傳進度 -->
                        <div class="upload-progress-bar" *ngIf="isUploading">
                            <div class="progress-content">
                                <div class="spinner-small"></div>
                                <span>正在處理圖片...</span>
                            </div>
                        </div>

                        <!-- 檔案資訊 -->
                        <div class="file-info-card" *ngIf="selectedFile">
                            <div class="file-icon">
                                <svg width="20" height="20" fill="#28a745" viewBox="0 0 16 16">
                                    <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5L14 4.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5h-2z"/>
                                </svg>
                            </div>
                            <div class="file-details">
                                <div class="file-name">{{ selectedFile.name }}</div>
                                <div class="file-size">{{ formatFileSize(selectedFile.size) }}</div>
                            </div>
                            <div class="file-badge">{{ isEditMode ? '新圖片' : '已選擇' }}</div>
                        </div>
                    </div>
                </div>

                <!-- 統計資訊 - 僅編輯模式顯示 -->
                <div class="form-section" *ngIf="isEditMode && editingGift">
                    <h4 class="section-title">統計資訊</h4>
                    <div class="stats-grid">
                        <div class="stat-item">
                            <span class="stat-label">建立時間</span>
                            <span class="stat-value">{{ formatDate(editingGift.create_dt) }}</span>
                        </div>
                        <div class="stat-item">
                            <span class="stat-label">最後更新</span>
                            <span class="stat-value">{{ formatDate(editingGift.update_dt) }}</span>
                        </div>
                        <div class="stat-item">
                            <span class="stat-label">排序順序</span>
                            <span class="stat-value">{{ editingGift.sort }}</span>
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn-cancel" (click)="closeGiftModal()">取消</button>
            <button type="button" class="btn-save" (click)="saveGift()">
                {{ isEditMode ? '保存' : '新增禮物' }}
            </button>
        </div>
    </div>
</div>


<!-- 禮物分類 -->
<!-- 彈跳背景 -->
<div class="modal-backdrop" *ngIf="showCategoryModal"></div>

<!-- 彈跳視窗 -->
<div class="modal" *ngIf="showCategoryModal">
    <div class="modal-header">
        <h3 *ngIf="!isAddingCategory">禮物類別</h3>
        <h3 *ngIf="isAddingCategory">新增類別</h3>
        <button class="close-btn" (click)="closeCategoryModal()">×</button>
    </div>

    <div class="modal-body">
       <!-- 類別列表 -->
        <div *ngIf="!isAddingCategory">

            <!-- 狀態篩選按鈕 -->
            <div class="category-filter-section">
                <button class="btn-primary" (click)="openAddCategoryForm()" style="margin-bottom: 10px;">＋ 新增類別</button>
                <div class="filter-buttons" style="margin-bottom: 10px;">
                    <button
                        class="filter-btn"
                        [class.active]="categoryStatusFilter === 'all'"
                        (click)="filterCategoryByStatus('all')">
                        全部 ({{ categoryList.length }})
                    </button>

                    <button
                        class="filter-btn status-active"
                        [class.active]="categoryStatusFilter === '1'"
                        (click)="filterCategoryByStatus('1')">
                        啟用 ({{ activeCount }})
                    </button>

                    <button
                        class="filter-btn status-inactive"
                        [class.active]="categoryStatusFilter === '0'"
                        (click)="filterCategoryByStatus('0')">
                        停用 ({{ inactiveCount }})
                    </button>
                </div>
            </div>

            <table class="table table-bordered table-hover">
                <thead>
                    <tr>
                        <th>分類名稱</th>
                        <th>排序</th>
                        <th>狀態</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let cat of filteredCategoryList" [ngClass]="'level-' + cat.level">
                        <!-- 分類名稱加縮排 -->
                        <td>
                            <span [style.padding-left.px]="cat.level * 20">
                                {{ cat.name }}
                            </span>
                        </td>
                        <td>{{ cat.sort }}</td>
                        <td>{{ cat.status == 1 ? '啟用' : '停用' }}</td>
                        <td>
                            <button class="btn-sm btn-warning" (click)="editCategory(cat)">
                                編輯
                            </button>
                            <button class="btn-sm btn-danger" (click)="deleteCategory(cat)">
                                刪除
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- 新增類別表單 -->
        <div *ngIf="isAddingCategory">
            <!-- 父分類選擇 -->
            <label>父分類</label>
            <select [(ngModel)]="newCategory.parent_id" class="form-control mb-2">
                <option value="0">無（建立為最上層）</option>
                <option *ngFor="let cat of categoryList" [value]="cat.id">
                    {{ '--'.repeat(cat.level) }} {{ cat.name }}
                </option>
            </select>

            <!-- 輸入名稱 -->
            <label>分類名稱</label>
            <input
                type="text"
                [(ngModel)]="newCategory.name"
                class="form-control mb-2"
                placeholder="請輸入分類名稱"
            />

            <!-- 輸入排序 -->
            <label>排序</label>
            <input
                type="number"
                [(ngModel)]="newCategory.sort"
                class="form-control mb-2"
                placeholder="數字越小排序越前"
            />

            <!-- 狀態 -->
            <label>狀態</label>
            <select [(ngModel)]="newCategory.status" class="form-control mb-2" [disabled]="typeChange == 0">
                <option value="1">啟用</option>
                <option value="0">停用</option>
            </select>
        </div>
    </div>

    <div class="modal-footer">
        <button
            class="btn-secondary"
            *ngIf="!isAddingCategory"
            (click)="closeCategoryModal()"
        >
            關閉
        </button>
        <button
            class="btn-secondary"
            *ngIf="isAddingCategory"
            (click)="cancelAddCategory()"
        >
            取消
        </button>
        <button
            class="btn-primary"
            *ngIf="isAddingCategory"
            (click)="submitNewCategory()"
        >
            確認
        </button>
    </div>
</div>

<!-- 在你現有的 HTML 檔案最後（在最後的 </div> 之前）新增以下完整的兌換申請單彈窗： -->

<!-- 兌換申請單管理彈窗 -->
<div *ngIf="showRedemptionModal" class="modal-overlay" (click)="onModalBackdropClick($event)">
    <div class="redemption-modal-container">
        <!-- 標題欄 -->
        <div class="modal-header">
            <h3 class="modal-title">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16" class="title-icon">
                    <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                </svg>
                禮物兌換申請單管理
            </h3>
            <button class="modal-close" (click)="closeRedemptionModal()">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </button>
        </div>

        <!-- 載入狀態 -->
        <div *ngIf="redemptionLoading" class="loading-overlay">
            <div class="spinner"></div>
            <p>載入兌換申請單中...</p>
        </div>

        <!-- 主要內容 -->
        <div *ngIf="!redemptionLoading" class="redemption-content">
            <!-- 工具列 -->
            <div class="redemption-toolbar">
                <!-- 搜尋列 -->
                <div class="search-section">
                    <div class="search-bar">
                        <input
                            type="text"
                            placeholder="搜尋禮物名稱、申請人或收件人..."
                            [(ngModel)]="redemptionSearchTerm"
                            (input)="filterRedemptionOrders()"
                            class="search-input"
                        />
                        <svg class="search-icon" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                        </svg>
                    </div>
                </div>

                <!-- 操作按鈕 -->
                <div class="toolbar-actions">
                    <button class="btn-export" (click)="exportRedemptionOrders()">
                        <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                            <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z"/>
                        </svg>
                        匯出
                    </button>
                    <button class="btn-refresh" (click)="refreshRedemptionOrders()">
                        <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                            <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                        </svg>
                        重新整理
                    </button>
                </div>
            </div>

            <!-- 狀態篩選標籤 -->
            <div class="status-filters">
                <button
                    *ngFor="let status of redemptionStatusOptions"
                    class="status-filter-tab"
                    [class.active]="selectedRedemptionStatus === status.value"
                    [ngClass]="'filter-' + status.value"
                    (click)="filterByRedemptionStatus(status.value)"
                >
                    <span class="filter-label">{{ status.label }}</span>
                    <span class="filter-count">{{ status.count }}</span>
                </button>
            </div>

            <!-- 申請單列表 -->
            <div class="redemption-list-container">
                <div *ngIf="filteredRedemptionOrders.length === 0" class="empty-state">
                    <div class="empty-icon">
                        <svg width="48" height="48" fill="#dee2e6" viewBox="0 0 16 16">
                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
                        </svg>
                    </div>
                    <h3>沒有找到兌換申請單</h3>
                    <p>{{ redemptionSearchTerm ? '嘗試調整搜尋條件' : '目前沒有任何兌換申請單' }}</p>
                </div>

                <div *ngIf="filteredRedemptionOrders.length > 0" class="redemption-list">
                    <div
                        *ngFor="let order of filteredRedemptionOrders; trackBy: trackByRedemptionId"
                        class="redemption-item"
                        [ngClass]="'status-' + order.status"
                        (click)="viewRedemptionDetails(order)"
                    >
                        <!-- 左側：禮物資訊 -->
                        <div class="item-gift-info">
                            <div class="gift-image-wrapper">
                                <img loading="lazy" [src]="order.image" [alt]="order.gitf_name" class="gift-thumbnail" (error)="onImageError($event)">
                                <div class="quantity-badge">{{ order.num }}件</div>
                            </div>
                            <div class="gift-details">
                                <h4 class="gift-name">{{ order.gitf_name }}</h4>
                                <div class="order-id">申請單 #{{ order.id }}</div>
                            </div>
                        </div>

                        <!-- 中間：申請人資訊 -->
                        <div class="item-user-info">
                            <div class="user-avatar">
                                <img loading="lazy" [src]="order.profile_pic" [alt]="order.user_name" class="avatar-img" (error)="onImageError($event)">
                            </div>
                            <div class="user-details">
                                <div class="user-name">{{ order.user_name }}</div>
                                <div class="user-phone">{{ order.user_phone_num }}</div>
                                <div class="delivery-info">
                                    <svg width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                    </svg>
                                    收件人: {{ order.name }} ({{ order.phone }})
                                </div>
                            </div>
                        </div>

                        <!-- 右側：狀態和時間 -->
                        <div class="item-status-info">
                            <div class="status-badge" [ngClass]="getRedemptionStatusClass(order.status)">
                                {{ getRedemptionStatusText(order.status) }}
                            </div>
                            <div class="time-info">
                                <div class="create-time">申請: {{ formatDate(order.create_dt) }}</div>
                                <div class="update-time" *ngIf="order.update_dt !== order.create_dt">
                                    更新: {{ formatDate(order.update_dt) }}
                                </div>
                            </div>

                            <!-- 快速操作按鈕 -->
                            <div class="quick-actions" (click)="$event.stopPropagation()">
                                <button
                                    class="quick-btn edit"
                                    (click)="editRedemptionOrder(order)"
                                    title="編輯"
                                >
                                    <svg width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708L10.5 8.207l-3-3L12.146.146zM11.207 9L8 5.793 1.146 12.646a.5.5 0 0 0-.146.354v2.5a.5.5 0 0 0 .5.5h2.5a.5.5 0 0 0 .354-.146L11.207 9z"/>
                                    </svg>
                                </button>
                                <button
                                    *ngIf="order.status === '0'"
                                    class="quick-btn approve"
                                    (click)="updateRedemptionStatus(order.id, '1')"
                                    title="完成"
                                >
                                    <svg width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.061L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                                    </svg>
                                </button>
                                <button
                                    *ngIf="order.status === '0'"
                                    class="quick-btn reject"
                                    (click)="updateRedemptionStatus(order.id, '-1')"
                                    title="拒絕"
                                >
                                    <svg width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- 兌換申請單詳情彈窗 -->
<div *ngIf="showRedemptionDetailModal && selectedRedemptionOrder" class="modal-overlay" (click)="onModalBackdropClick($event)">
    <div class="detail-modal-container">
        <div class="modal-header">
            <h3 class="modal-title">
                兌換申請單詳情 #{{ selectedRedemptionOrder.id }}
            </h3>
            <button class="modal-close" (click)="closeRedemptionDetailModal()">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <!-- 狀態標題 -->
            <div class="detail-status-header">
                <div class="status-badge large" [ngClass]="getRedemptionStatusClass(selectedRedemptionOrder.status)">
                    {{ getRedemptionStatusText(selectedRedemptionOrder.status) }}
                </div>
                <div class="status-time">
                    申請時間：{{ selectedRedemptionOrder.create_dt }}
                </div>
            </div>

            <!-- 詳情內容 -->
            <div class="detail-content">
                <!-- 禮物資訊 -->
                <div class="detail-section">
                    <h4 class="section-title">
                        <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748z"/>
                        </svg>
                        兌換禮物
                    </h4>
                    <div class="gift-detail-card">
                        <img loading="lazy" [src]="selectedRedemptionOrder.image" [alt]="selectedRedemptionOrder.gitf_name" class="detail-gift-image">
                        <div class="gift-detail-info">
                            <h3>{{ selectedRedemptionOrder.gitf_name }}</h3>
                            <div class="quantity-info">申請數量：<span class="highlight">{{ selectedRedemptionOrder.num }}</span> 件</div>
                        </div>
                    </div>
                </div>

                <!-- 申請人資訊 -->
                <div class="detail-section">
                    <h4 class="section-title">
                        <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z"/>
                        </svg>
                        申請人資訊
                    </h4>
                    <div class="user-detail-card">
                        <img loading="lazy" [src]="selectedRedemptionOrder.profile_pic" [alt]="selectedRedemptionOrder.user_name" class="detail-user-avatar">
                        <div class="user-detail-info">
                            <div class="info-row">
                                <span class="label">姓名：</span>
                                <span class="value">{{ selectedRedemptionOrder.user_name }}</span>
                            </div>
                            <div class="info-row">
                                <span class="label">聯絡電話：</span>
                                <span class="value">{{ selectedRedemptionOrder.user_phone_num }}</span>
                            </div>
                            <div class="info-row">
                                <span class="label">用戶ID：</span>
                                <span class="value">#{{ selectedRedemptionOrder.user_id }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 收件人資訊 -->
                <div class="detail-section">
                    <h4 class="section-title">
                        <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z"/>
                        </svg>
                        配送資訊
                    </h4>
                    <div class="shipping-detail-card">
                        <div class="info-grid">
                            <div class="info-row">
                                <span class="label">收件人：</span>
                                <span class="value">{{ selectedRedemptionOrder.name }}</span>
                            </div>
                            <div class="info-row">
                                <span class="label">收件電話：</span>
                                <span class="value">{{ selectedRedemptionOrder.phone }}</span>
                            </div>
                            <div class="info-row">
                                <span class="label">配送方式：</span>
                                <span class="value delivery-type">{{ getDeliveryTypeText(selectedRedemptionOrder.type) }}</span>
                            </div>
                            <div class="info-row full-width">
                                <span class="label">配送地址：</span>
                                <span class="value address">{{ selectedRedemptionOrder.address }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 處理記錄 -->
                <div class="detail-section">
                    <h4 class="section-title">
                        <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"/>
                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"/>
                        </svg>
                        處理記錄
                    </h4>
                    <div class="timeline">
                        <div class="timeline-item">
                            <div class="timeline-icon created">
                                <svg width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                </svg>
                            </div>
                            <div class="timeline-content">
                                <div class="timeline-title">申請提交</div>
                                <div class="timeline-time">{{ selectedRedemptionOrder.create_dt }}</div>
                            </div>
                        </div>
                        <div class="timeline-item" *ngIf="selectedRedemptionOrder.update_dt !== selectedRedemptionOrder.create_dt">
                            <div class="timeline-icon" [ngClass]="getRedemptionStatusClass(selectedRedemptionOrder.status)">
                                <svg *ngIf="selectedRedemptionOrder.status === '1'" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.061L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                                </svg>
                                <svg *ngIf="selectedRedemptionOrder.status === '-1'" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                </svg>
                            </div>
                            <div class="timeline-content">
                                <div class="timeline-title">狀態更新為：{{ getRedemptionStatusText(selectedRedemptionOrder.status) }}</div>
                                <div class="timeline-time">{{ selectedRedemptionOrder.update_dt }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 操作區域 -->
        <div class="modal-footer" *ngIf="selectedRedemptionOrder.status === '0'">
            <button class="btn-reject" (click)="updateRedemptionStatus(selectedRedemptionOrder.id, '-1')">
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
                拒絕申請
            </button>
            <button class="btn-approve" (click)="updateRedemptionStatus(selectedRedemptionOrder.id, '1')">
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.061L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                </svg>
                完成兌換
            </button>
        </div>
        <div class="modal-footer" *ngIf="selectedRedemptionOrder.status !== '0'">
            <button class="btn-cancel" (click)="closeRedemptionDetailModal()">關閉</button>
        </div>
    </div>
</div>

<!-- 編輯兌換申請單彈窗 -->
<div *ngIf="showEditRedemptionModal" class="modal-overlay">
    <div class="modal-container">
        <div class="modal-header">
            <h3 class="modal-title">修改兌換申請單 #{{ editRedemptionForm.id }}</h3>
            <button class="modal-close" (click)="closeEditRedemptionModal()">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
            </button>
        </div>

        <div class="modal-body">
            <div class="form-section">
                <h4 class="section-title">收件人資訊</h4>
                <div class="form-grid">
                    <div class="form-group">
                        <label class="form-label">收件人姓名 <span class="required">*</span></label>
                        <input type="text" class="form-input" [(ngModel)]="editRedemptionForm.name" />
                    </div>
                    <div class="form-group">
                        <label class="form-label">聯絡電話 <span class="required">*</span></label>
                        <input type="tel" class="form-input" [(ngModel)]="editRedemptionForm.phone" />
                    </div>
                </div>
            </div>

            <div class="form-section">
                <h4 class="section-title">配送資訊</h4>
                <div class="form-group">
                    <label class="form-label">配送方式</label>
                    <select class="form-select" [(ngModel)]="editRedemptionForm.type">
                        <option *ngFor="let option of deliveryTypeOptions" [value]="option.value">
                            {{ option.label }}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label class="form-label">配送地址 <span class="required">*</span></label>
                    <textarea class="form-input" [(ngModel)]="editRedemptionForm.address" rows="3" [readonly]="editRedemptionForm.status == 2 || editRedemptionForm.status == 3"></textarea>
                </div>
                <div class="form-group">
                    <label class="form-label">處理狀態</label>
                    <select class="form-select" [(ngModel)]="editRedemptionForm.status">
                        <option *ngFor="let status of allStatusOptions" [value]="status.value">
                            {{ status.label }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn-cancel" (click)="closeEditRedemptionModal()">取消</button>
            <button type="button" class="btn-save" (click)="saveEditedRedemptionOrder()" [disabled]="isUpdatingRedemption">
                {{ isUpdatingRedemption ? '儲存中...' : '儲存修改' }}
            </button>
        </div>
    </div>
</div>
